export enum SHARED_API_ROUTES {
    STUDENT = '/share/student/{token}',
    STUDENT_LEARNING_ACTIVITY_PROGRESS = '/share/user-progress/chart/{token}',
    STUDENT_DIFFICULT_LESSONS = '/share/practice-mores/difficult-lessons/{token}',
    STUDENT_THEMES = '/share/themes/{token}',
    STUDENT_SIMULATIONS = '/share/simulations/{token}',
    STUDENT_SIMULATION = '/share/simulations/{simulationId}/{token}',
}
